// extracted by mini-css-extract-plugin
module.exports = {"root":"dynamic-height_root__o9wbW"};